import type { ValueOf } from '@kc-console/core';
import type { InlineMessageSize } from '../InlineMessage/constants';

export const FormFieldLabelPositionSet = ['top', 'left'] as const;
export type FormFieldLabelPosition = ValueOf<typeof FormFieldLabelPositionSet>;

export const FormFieldSizeSet = ['sm', 'md', 'lg'] as const;
export type FormFieldSize = ValueOf<typeof FormFieldSizeSet>;

export const getInlineMessageSize = (size: FormFieldSize) => {
  const mapper: Record<FormFieldSize, InlineMessageSize> = {
    sm: 'xs',
    md: 'sm',
    lg: 'md',
  };
  return mapper[size];
};
